import { StyleSheet } from 'react-native';
import { DynamicStyleSheet, minWidth } from '@pulsar/core';
import { Platform } from 'src/libs/platform';

export default DynamicStyleSheet.create(theme => ({
  root: {
    backgroundColor: 'transparent',
    paddingVertical: 8,
    ...minWidth(theme.breakpoints.tablet, {
      backgroundColor: theme.colors.cardBG,
      borderWidth: StyleSheet.hairlineWidth,
      borderColor: theme.colors.cardBorder,
      borderRadius: Platform.select({
        ios: theme.radii.ios,
        android: theme.radii.android,
        default: theme.radii.web,
      }),
      padding: 8,
    }),
  },
  separator: {
    borderBottomWidth: 1,
    borderColor: theme.colors.separator,
    marginVertical: 8,
    ...minWidth(theme.breakpoints.tablet, {
      borderBottomWidth: 0,
    }),
  },
}));
